import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Message } from '../kernel/api';

@Component({
    selector: 'p-messages',
    styles: [`
        .ui-messages-icon {
            display: inline-block;
            padding: 0;
            vertical-align: middle;
        }

        .ui-messages-summary {
            font-weight: bold;
            margin-left: .25em;
        }

        .ui-messages-detail {
            margin-left: .25em;
        }

        ul {
            margin: 0;
            padding: 0;
            list-style-type: none;
            display: inline-block;
            vertical-align: middle;
        }


    `],
    template: `
        <div *ngIf="hasMessages()" class="alert alert-dismissible fade show" role="alert" style="display:block"
             [ngClass]="{'alert--info':(value[0].severity === 'info'),
                    'alert-warn':(value[0].severity === 'warn'),
                    'alert-danger ':(value[0].severity === 'error'),
                    'alert-success':(value[0].severity === 'success')}">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close" *ngIf="closable">
                <span aria-hidden="true">&times;</span>
            </button>

            <span class="ui-messages-icon fa fa-fw fa-lg" [ngClass]="icon"></span>
            <ul>
                <li *ngFor="let msg of value">
                    <span class="ui-messages-summary">{{msg.summary}}</span>
                    <span class="ui-messages-detail">{{msg.detail}}</span>
                </li>
            </ul>
        </div>
    `
})
export class Messages {

    @Input() value: Message[];

    @Input() closable: boolean = true;

    hasMessages() {
        return this.value && this.value.length > 0;
    }

    getSeverityClass() {
        return this.value[0].severity;
    }

    clear(event) {
        this.value.splice(0, this.value.length);

        event.preventDefault();
    }

    get icon(): string {
        let icon: string = null;
        if ( this.hasMessages() ) {
            let msg = this.value[0];
            switch ( msg.severity ) {
                case 'success':
                    icon = 'fa-check';
                    break;

                case 'info':
                    icon = 'fa-info-circle';
                    break;

                case 'error':
                    icon = 'fa-close';
                    break;

                case 'warn':
                    icon = 'fa-warning';
                    break;

                case 'success':
                    icon = 'fa-check';
                    break;

                default:
                    icon = 'fa-info-circle';
                    break;
            }
        }

        return icon;
    }
}

@NgModule({
    imports: [CommonModule],
    exports: [Messages],
    declarations: [Messages]
})
export class MessagesModule {
}